import './index.css';
import React from 'react';

const DommusRequiredSpan = (props) => {
	return <span className="help-text">*</span>;
};

export default DommusRequiredSpan;